const expressions = require('angular-expressions');

expressions.filters.indexOf = (input: any, search: any) => {
    return input.indexOf(search);
};

expressions.filters.map = (input: any, pathString: any) => {
    const path = pathString.split('.');
    return input.map((a: any) => {
        for (let i = 0; i < path.length; i++) {
            if (typeof a !== 'object') {
                return null;
            } else {
                a = a[path[i]];
            }
        }
        return a;
    });
};

expressions.filters.contains = (input: any, search: any) => {
    return input.indexOf(search) > -1;
};

expressions.filters.substring = (input: any, from: number, to: number) => {
    return input.substring(from, to);
};

expressions.filters.emptyIf = (input: any, condition: boolean) => {
    return condition ? '' : input;
};

expressions.filters.firstWithLengthInRange = (input: string[], minLength: number, maxLength: number) => {
    return input.find((str) => str.length >= minLength && str.length <= maxLength);
};

const ExpressionsService = {
    evaluate: (expression: string, scope: any) => {
        const evaluate = expressions.compile(expression);
        try {
            return evaluate(scope);
        } catch (e) {
            console.error('Failed to evaluate expression:', expression);
            console.error(e);
            return false;
        }
    },

    processTemplate: (template: string, scope: any) => {
        return ('' + template).replace(/{{(.*?)}}/g, (_a, b) => {
            const result = ExpressionsService.evaluate(b, scope);
            return result === undefined ? '' : '' + result;
        });
    },
};

export default ExpressionsService;
